module.exports = __webpack_public_path__ + "img/24-06_bar-menu2.bf144be1.jpg";